import { ChangePasswordModel } from "libs/models/change-password";
import { ValidationModel } from "libs/models/validate-model";
import translate from "utils/translations";
import { LoginStore } from "store/slices/login";
import { passwordRegex } from "utils/regex";

export const validateChangePasswordState = (
  state: LoginStore
): ValidationModel<ChangePasswordModel> => {
  const validationModel = {} as ValidationModel<ChangePasswordModel>;
  if (!state.isChangePasswordValidating) {
    return validationModel;
  }
  if (!state.changePasswordModel.oldPassword) {
    validationModel.oldPassword = translate(
      "Required_Text",
      "This field is required"
    );
  }

  if (!state.changePasswordModel.newPassword) {
    validationModel.newPassword = translate(
      "Required_Text",
      "This field is required"
    );
  } else if (
    state.changePasswordModel.newPassword ===
    state.changePasswordModel.oldPassword
  ) {
    validationModel.newPassword = translate(
      "New_Password_Same_As_Old_Error",
      "New password cannot be the same as the old password."
    );
  } else { 
    if (!passwordRegex.test(state.changePasswordModel.newPassword)) {
      validationModel.newPassword = translate(
        "Password_Policy_Error",
        "Password must be at least 8 characters long, contain one uppercase letter, one number, and one special character."
      );
    }
  }

  if (!state.changePasswordModel.confirmNewPassword) {
    validationModel.confirmNewPassword = translate(
      "Required_Text",
      "This field is required"
    );
  } else if (
    state.changePasswordModel.newPassword !==
    state.changePasswordModel.confirmNewPassword
  ) {
    validationModel.confirmNewPassword = translate(
      "Password_Mismatch_Error",
      "Passwords do not match."
    );
  }
  return validationModel;
};
